import { Link } from 'react-router-dom';
import PulseDot from '@/components/atoms/PulseDot';
import BrandMark from '@/components/atoms/BrandMark';

const cols = [
  { heading: 'Products', links: [
    { label: 'DrkLynX Hosting', href: '/products/hosting' },
    { label: 'DrkLynX Domains', href: '/domains' },
    { label: 'DrkLynX Weaver', href: '/products/weaver' },
    { label: 'ZbraLynX', href: '/products/zbralynx' },
    { label: 'DrkLynX Crossing', href: '/products/crossing' },
  ]},
  { heading: 'Resources', links: [
    { label: 'Documentation', href: '/docs' },
    { label: 'Blog', href: '/resources/blog' },
    { label: 'Status', href: '/status' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Trust Center', href: '/trust' },
  ]},
  { heading: 'Company', links: [
    { label: 'About DrkLynX', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'Ledger Pulse', href: '/ledger-pulse' },
  ]},
  { heading: 'Legal', links: [
    { label: 'Terms of Service', href: '/legal/terms' },
    { label: 'Privacy Policy', href: '/legal/privacy' },
    { label: 'Acceptable Use', href: '/legal/acceptable-use' },
    { label: 'DPA', href: '/legal/dpa' },
  ]},
];

const Footer = () => (
  <footer data-testid="footer" className="border-t border-signal/10 bg-obsidian" role="contentinfo">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 lg:gap-12 mb-16">
        {cols.map((col) => (
          <div key={col.heading}>
            <div className="font-mono text-[10px] tracking-wider uppercase text-steel-muted mb-4">{col.heading}</div>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-sm text-steel hover:text-cyan transition-colors duration-fast">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Trust badges */}
      <div className="flex flex-wrap gap-4 mb-8">
        {['PQC-Hardened', 'Post-Quantum Ready · Phase A', 'Ledger Pulse Active'].map((b) => (
          <span key={b} className="font-mono text-[10px] tracking-wider uppercase px-3 py-1 border border-green/20 rounded text-green/70">{b}</span>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-signal/5">
        <div className="flex items-center gap-4">
          <img src="/logo-drklynx-sm.png" alt="DrkLynX" className="w-24 h-24 rounded-md drop-shadow-xl" />
          <div className="flex flex-col gap-1">
            <BrandMark size="lg" />
            <span className="text-steel-muted text-xs">&copy; {new Date().getFullYear()} DrkLynX LLC. All rights reserved.</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <PulseDot status="online" />
          <span className="font-mono text-[10px] text-steel-muted uppercase tracking-wider">All Systems Operational</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
